import { Property } from '@givebacks/api/backer';
import { DateTime } from 'luxon';
import {
  DatePickerInput,
  MultiSelect,
  NumberInput,
  Select,
  TextInput,
  Textarea,
  TimeInput,
} from 'ui';

const PropertyFieldValue = ({
  property,
  onChange,
  label = 'Value',
  value,
  readOnly = false,
}: {
  property?: Property;
  onChange: (value: string) => void;
  label?: string;
  value?: string;
  readOnly?: boolean;
}) => {
  if (property?.field_type == 'boolean') {
    return (
      <Select
        data={[
          { value: 'true', label: 'True' },
          { value: 'false', label: 'False' },
        ]}
        placeholder="Select an option"
        label={label}
        value={value}
        onChange={(value) => {
          onChange(value ?? '');
        }}
        readOnly={readOnly}
      />
    );
  }

  if (property?.field_type == 'cents' || property?.field_type == 'number') {
    return (
      <NumberInput
        placeholder="Enter Value"
        onChange={(value) => {
          onChange(String(value ?? ''));
        }}
        value={value}
        label={label}
        disabled={!property?.uuid}
        readOnly={readOnly}
      />
    );
  }

  if (property?.field_type == 'date') {
    return (
      <DatePickerInput
        placeholder="Select an date"
        type="default"
        label={label}
        value={value ? DateTime.fromISO(value).toJSDate() : undefined}
        onChange={(value) => {
          onChange(value ? (DateTime.fromJSDate(value as Date).toISO() ?? '') : '');
        }}
        readOnly={readOnly}
      />
    );
  }

  if (property?.field_type == 'datetime') {
    return (
      <TimeInput
        placeholder="Select an date"
        type="default"
        label={label}
        value={value}
        onChange={(event) => {
          onChange(event?.target.value ?? '');
        }}
        readOnly={readOnly}
      />
    );
  }

  if (property?.field_type == 'dropdown') {
    return (
      <Select
        data={property?.options}
        label={label}
        placeholder="Select an option"
        value={value}
        onChange={(value) => {
          onChange(value ?? '');
        }}
        readOnly={readOnly}
      />
    );
  }

  if (property?.field_type == 'multiselect') {
    return (
      <MultiSelect
        data={property?.options}
        label={label}
        placeholder="Select an option"
        value={value ? value.split(' | ') : []}
        onChange={(value) => {
          onChange(value.join(' | '));
        }}
        readOnly={readOnly}
      />
    );
  }

  if (property?.field_type == 'textarea') {
    return (
      <Textarea
        placeholder="Enter Value"
        value={value}
        onChange={(event) => {
          onChange(event.target.value ?? '');
        }}
        label={label}
        readOnly={readOnly}
        autosize
        maxRows={5}
      />
    );
  }

  return (
    <TextInput
      placeholder="Enter Value"
      value={value}
      onChange={(event) => {
        onChange(event.target.value ?? '');
      }}
      label={label}
      disabled={!property?.uuid}
      readOnly={readOnly}
    />
  );
};

export { PropertyFieldValue };
